import React, { useState } from 'react';
import MyTabs from 'components/home/MyTabs';
import Report from 'components/report/Report';
import TextReport from './TextReport';
import { getReportTexts } from 'store/store';

export default function ReportTabs() {
  const [currentTab, setCurrentTab] = useState(0);

  var tabCount = 1;
  var tabList = ['XML Report'];
  var tf = getReportTexts();
  for (var ix = 0; ix < tf.length; ++ix) {
    var title = tf[ix].Repository;
    title += " Text"
    tabList.push(title);
    ++tabCount
  };

  //console.log("tabList: ", tabList);
 
  function onTabChange(n) {
    setCurrentTab(n);
  }

  return (
    <div className='w-full flex flex-col'>
      <MyTabs tabList={tabList} currentTab={currentTab} onTabChange={onTabChange} />
      <>
      {currentTab === 0 && <Report />}
      {currentTab === 1 && <TextReport ix={0} />}
      {currentTab === 2 && <TextReport ix={1} />}
      {currentTab === 3 && <TextReport ix={2} />}
      {currentTab === 4 && <TextReport ix={3} />}
      {currentTab === 5 && <TextReport ix={4} />}
      {currentTab === 6 && <TextReport ix={5} />}
      </>
    </div>
  );
}
